import { render, staticRenderFns } from "./InspectionTestPlanTask.vue?vue&type=template&id=f1d70570&"
import script from "./InspectionTestPlanTask.vue?vue&type=script&lang=js&"
export * from "./InspectionTestPlanTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports